import { BaseError } from './base.js';
export class SliceOffsetOutOfBoundsError extends BaseError {
  constructor(_ref) {
    let {
      offset,
      position,
      size
    } = _ref;
    super("Slice ".concat(position === 'start' ? 'starting' : 'ending', " at offset \"").concat(offset, "\" is out-of-bounds (size: ").concat(size, ")."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'SliceOffsetOutOfBoundsError'
    });
  }
}
export class SizeExceedsPaddingSizeError extends BaseError {
  constructor(_ref2) {
    let {
      size,
      targetSize,
      type
    } = _ref2;
    super("".concat(type.charAt(0).toUpperCase()).concat(type.slice(1).toLowerCase(), " size (").concat(size, ") exceeds padding size (").concat(targetSize, ")."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'SizeExceedsPaddingSizeError'
    });
  }
}
export class InvalidBytesLengthError extends BaseError {
  constructor(_ref3) {
    let {
      size,
      targetSize,
      type
    } = _ref3;
    super("".concat(type.charAt(0).toUpperCase()).concat(type.slice(1).toLowerCase(), " is expected to be ").concat(targetSize, " ").concat(type, " long, but is ").concat(size, " ").concat(type, " long."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'InvalidBytesLengthError'
    });
  }
}
//# sourceMappingURL=data.js.map